<template>
  <div class="form-picker">
    <span class="variable-label">
      {{ label }}
    </span>
    <div class="picker-container">
      <div v-if="isLoading" class="picker-loading">
        <spinner size="small" />
      </div>
      <select
        v-else
        v-model="selectedFormId"
        class="form-select"
        @change="onSelect"
      >
        <option value="" disabled>
          {{ $t('FORMS_MODAL.SELECT_FORM') }}
        </option>
        <option
          v-for="form in forms"
          :key="form.publicId"
          :value="form.publicId"
        >
          {{ form.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import Spinner from 'shared/components/Spinner.vue';
import FormsAPI from 'dashboard/api/integrations/forms';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  name: 'FormPicker',
  components: {
    Spinner,
  },
  mixins: [alertMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      forms: [],
      selectedFormId: '',
      isLoading: false,
    };
  },
  mounted() {
    this.fetchForms();
  },
  methods: {
    async fetchForms() {
      this.isLoading = true;
      this.forms = [];
      try {
        const response = await FormsAPI.getFormsList();
        this.forms = response.data || [];
      } catch (error) {
        console.error('FormPicker error:', error);
        this.showAlert(this.$t('FORMS_MODAL.LOAD_ERROR'));
      } finally {
        this.isLoading = false;
      }
    },
    onSelect() {
      const form = this.forms.find(f => f.publicId === this.selectedFormId);
      this.$emit('form-selected', form);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-picker {
  display: flex;
  align-items: center;
  margin-bottom: 0.625rem;

  .picker-container {
    flex: 1;
    margin-left: 0.625rem;
  }

  .form-select {
    padding: 0.5rem;
    margin-bottom: 0;
  }

  .picker-loading {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
  }
}
</style>
